<template>
  <div class="not-found">
    <span class="not-found__error-code">
      {{ $t('thanksForQuote') }}
    </span>
    <span class="not-found__title">
      {{ $t('thePageThanks') }}
    </span>
    <p class="not-found__description" v-html="$t('thePageThanksDescription')" />

    <router-link class="btn-main margin-right-20" :to="{ name: 'home' }">
      {{ $t('newConfiguration') }}
    </router-link>

    <a :href="companyInfo.url" class="btn-main btn-main--white" >
        {{ $t('backToHomePage') }}
    </a>

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import store from '@/store/index';

  export default {
    name: 'Thanks',
    metaInfo () {
      const {companyInfo, $t } = this;
      return {
        title: $t('thePageThanks') + ' | ' + companyInfo.seo_title + ' | ' + $t('titleWindowConfigurator'),
      }
    },
    computed: {
      ...mapState({
        companyInfo: state => state.companyInfo,
      })
    }
  };
</script>

<style scoped>
    .margin-right-20 {
        margin-right: 20px;
    }
    @media (min-width: 991px) {
        .not-found {
            margin-top: -100px;
        }
    }
 
</style>

